import { useEffect, useState } from "react";
import Modal from "../../modal/Modal";

const ALL_EDI_EXTRACT_JOBS = [
    "hrp_enrollment",
    "hrp_accum",
    "hrp_benefit_plan",
    "hrp_claims_paid",
    "hrp_claims_nonpaid",
];

const EdiExtractConfirmModal = ({ isOpen, onClose, isPending, onConfirm, jobs }) => {
    const isRetry = jobs?.length > 0;
    const [selected, setSelected] = useState(() => (isRetry ? jobs : []));

    useEffect(() => {
        if (isOpen) setSelected(jobs?.length > 0 ? jobs : []);
    }, [isOpen, jobs]);

    const toggle = (job) =>
        setSelected((prev) =>
            prev.includes(job) ? prev.filter((j) => j !== job) : [...prev, job]
        );

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <div className="edi-extract-confirm-modal">
                <p className="edi-extract-confirm-modal__heading">
                    {isRetry ? `Retry ${jobs.join(", ")}?` : "Run the EDI extract now?"}
                </p>
                <p className="edi-extract-confirm-modal__body">
                    {isRetry
                        ? "These are the jobs that failed last run — uncheck any you don't want to retry."
                        : "Choose which jobs to run:"}
                </p>
                <div className="edi-extract-confirm-modal__checklist">
                    {ALL_EDI_EXTRACT_JOBS.map((job) => (
                        <label key={job} className="edi-extract-confirm-modal__checkbox">
                            <input
                                type="checkbox"
                                checked={selected.includes(job)}
                                onChange={() => toggle(job)}
                            />
                            {job}
                        </label>
                    ))}
                </div>
                {selected.length >= 3 && (
                    <p className="edi-extract-confirm-modal__warning">
                        Running several jobs at once may take a while to finish.
                    </p>
                )}
                <p className="edi-extract-confirm-modal__body">
                    It can't be cancelled once started, and you won't be able to
                    start another run until this one finishes.
                </p>
                <div className="edi-extract-selfservice-modal__actions">
                    <button className="finance-ops__link-btn" onClick={onClose}>
                        Cancel
                    </button>
                    <button
                        className="finance-ops__primary-btn"
                        disabled={isPending || selected.length === 0}
                        onClick={() => onConfirm(selected.length === ALL_EDI_EXTRACT_JOBS.length ? undefined : selected)}
                    >
                        {isPending ? "Starting…" : isRetry ? "Retry" : "Run extract"}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default EdiExtractConfirmModal;
